import React, { Component } from 'react';
import styled from 'styled-components';
import { A, Button, H4, IconX, Input, P, theme } from '@upsolve/ui';
import { ERROR_CODES } from '@upsolve/shared';

import ModalBackground from './ModalBackground';
import SCREENER_CTA_TYPES from '../analytics/screenerCtaTypes';
import getScreenerUrl from '../Links/getScreenerUrl';
import submitNewsletterSignup from '../CTA/submitNewsletterSignup';
import validateEmail from '../utils/validateEmail';
import withViewportWatch from '../analytics/withViewportWatch';

import Logo from '../../../static/images/upsolve-logo.svg';
import trackComponentImpression from '../analytics/trackComponentImpression';
import trackComponentAction from '../analytics/trackComponentAction';

const NewsletterPopupWrapper = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 5000;
  .newsletter-modal {
    &__panel {
      width: 420px;
      max-width: 100%;
      margin: 0 auto;
      padding-bottom: 2em;
      background: white;
      border-radius: 4px;
      h4 {
        line-height: 120%;
        text-align: center;
      }
      & > div {
        margin: 0 2em;
        padding: 1.5em 0;
      }
      .close {
        padding-bottom: 0;
        &:hover {
          cursor: pointer;
        }
        svg {
          height: 20px;
          width: 20px;
          path {
            fill: ${props => props.theme.colors.gray[700]};
          }
        }
      }
      .logo svg {
        fill: ${theme.colors.brand[500]}
      }
      .email-form {
        .newsletter-msg {
          width: 100%;
          p {
            width: 100%;
            text-align: center;
          }
        }
        .newsletter-submit-success p {
          color: ${theme.colors.green[100]}
        }
        .newsletter-submit-error p {
          color: ${theme.colors.red[500]}
        }
        input, button {
          margin: 0.25em 0;
        }
      }
      @media(max-width: 45em) {
        width: 100%;
        margin: 0;
      }
    }
  }
`;

const trackingProps = {
  componentName: 'NewsletterPopupModal',
  componentVersion: 0,
}

class NewsletterPopupModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      error: null,
      impressionTracked: false,
      submitted: false,
    }
  }

  async handleSubmit() {
    trackComponentAction({
      ...trackingProps,
      actionId: 'popupNewsletterSignup.newsletterSignup',
      actionMethod: 'click',
    });

    if (this.state.submitted) {
      return;
    }

    const { email } = this.state;
    const { isValid, error } = await validateEmail(email);

    if (!isValid) {
      this.setState({ error, submitted: false });
      return;
    }

    try {
      await submitNewsletterSignup(email);
      this.setState({ submitted: true, error: null });
    } catch (er) {
      this.setState({
        submitted: false,
        error: ERROR_CODES.UNHANDLED,
      });
    }
  }

  render() {
    const { submitted, error, impressionTracked } = this.state;

    if (this.props.isInViewport && !impressionTracked) {
      this.props.stopWatcher();
      trackComponentImpression(trackingProps)
        .then(() => this.setState({ impressionTracked: true }));
    }

    const currentYear = new Date().getFullYear()
    return (
      <NewsletterPopupWrapper>
        <ModalBackground onClick={() => this.props.onClose()}>
          <div
            className="newsletter-modal__panel"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="close">
              <IconX onClick={this.props.onClose} />
            </div>
            <div className="logo">
              <Logo />
            </div>
            <div>
              <H4>Get the definitive guide to filing bankruptcy in {currentYear}</H4>
            </div>
            <div className="email-form">
              <Input
                type="text"
                placeholder="Enter your email"
                onChange={(event) => this.setState({ email: event.target.value })}
              />
              <Button
                width="100%"
                disabled={submitted}
                onClick={() => this.handleSubmit()}
              >
                Get Access
              </Button>
              {submitted && (
                <div className="newsletter-msg newsletter-submit-success">
                  <P>Success!</P>
                </div>
              )}
              {error != null && (
                <div className="newsletter-msg newsletter-submit-error">
                  <P>
                    {(() => ({
                      [ERROR_CODES.INVALID_EMAIL]: 'Invalid e-mail address',
                      [ERROR_CODES.FILER_EXISTS]: 'Already signed up!',
                      [ERROR_CODES.UNHANDLED]: 'Error. Please try back later!',
                    }[error]))()}
                  </P>
                </div>
              )}
            </div>
            <div>
              <P style={{ textAlign: 'center' }}>
                <A href={getScreenerUrl({ cta: SCREENER_CTA_TYPES.NEWSLETTER_POPUP })}>
                  No thanks, take me to a tool to file bankruptcy for free.
                </A>
              </P>
            </div>
          </div>
        </ModalBackground>
      </NewsletterPopupWrapper>
    );
  }
}

export default withViewportWatch(NewsletterPopupModal);
